module.exports = __webpack_public_path__ + "static/media/total-services.e2217492.svg";